import { merge } from 'lodash-es';

import type { NormalizedDataInjection } from './types';

export function mergeNormalizedDataInjection(
  injection: NormalizedDataInjection,
  responseInjection: NormalizedDataInjection | undefined,
): NormalizedDataInjection {
  const normalized = injection.normalizedMultiple;
  const normalizedResponse = responseInjection?.normalizedMultiple;

  const existingEntities = normalized?.entities ?? {};
  const responseEntities = normalizedResponse?.entities ?? {};

  const existingIds = normalized?.result ?? [];
  const responseIds = normalizedResponse?.result ?? [];

  const result: NormalizedDataInjection = {
    normalizedMultiple: {
      entities: merge(existingEntities, responseEntities),
      result: [...existingIds, ...responseIds],
    },
  };
  return result;
}
